/**
 * Format stored calendar dates (YYYY-MM-DD) as DD/MM/YYYY for customer-facing UI.
 * Returns the original string if it is not a simple ISO date.
 */
export function formatIsoDateDdMmYyyy(iso: string): string {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

/** Today as YYYY-MM-DD in the user’s local timezone. */
export function todayLocalIsoDate(): string {
  const d = new Date();
  const z = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
}
